module.exports = __webpack_public_path__ + "img/history2.176289a7.png";